import * as z from 'zod';

import { BillSettingsId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';

export const BillSettingType = z.enum(['borrower', 'builder']);
export type BillSettingType = z.infer<typeof BillSettingType>;

export const BillSetting = z.object({
  id: BillSettingsId,
  type: BillSettingType,
  startDate: zodJSPlainDate,
});
export type BillSetting = z.infer<typeof BillSetting>;
